
import Utilities from './Utilities'

export default class {
    static getMasterKey() {
        return '-LG-kkb1y_ZwFJ9GYSZj'
    }

    static fieldTypes = [
        { name: 'Text', control: 'Text' },
        { name: 'Number', control: 'Number' },
        { name: 'List', control: 'Dropdown' },
        { name: 'Currency', control: 'Currency' },
        { name: 'Date', control: 'Date' },
        { name: 'True/False', control: 'Checkbox' },
        { name: 'Html', control: 'Html' },
        { name: 'Parent Table', control: 'Dropdown' },
        { name: 'Child Table', control: 'Dropdown' },
        { name: 'Calculated', control: 'Text' },
        { name: 'File', control: 'Upload' },
        { name: 'Image', control: 'Image' },
    ]

    static controlTypes = [
        { name: 'Text', field: 'Text' },
        { name: 'Text', field: 'Calculated' },
        { name: 'Number', field: 'Number' },
        { name: 'Dropdown', field: 'List' },
        { name: 'Currency', field: 'Currency' },
        { name: 'Date', field: 'Date' },
        { name: 'Checkbox', field: 'True/False' },
        { name: 'Switch', field: 'True/False'},
        { name: 'Options', field: 'List'},
        { name: 'Html', field: 'Html'},
        { name: 'Upload', field: 'File'},
        { name: 'Image', field: 'Image'},
    ]

    static actionTypes = [
        { name: 'Set Field Value' },
    ]

    static operators() {
        return [
            {code: 'e', name: 'Equals'},
            {code: 'ne', name: 'Not Equal'},
        ]
    }

    static officeTeams() {
        return {
            '1': 'Mortgage Choice Currimundi',
            '002': 'Mortgage Choice Buderim',
        }
    }

    static relationships() {
        return [
            {   text: 'Partner',    relatedText: 'Partner'  },
            {   text: 'Parent',    relatedText: 'Child'  },
            {   text: 'Child',    relatedText: 'Parent'  },
            {   text: 'Friend',    relatedText: 'Friend'  },
            {   text: 'Client',    relatedText: 'Consultant'  },
            {   text: 'Consultant',    relatedText: 'Client'  },
        ]
    }

    static processors() {
        return [
            {
                email: 'billing@insightprocessing.com.au',
                abn: '18 154 499 025 (Insight Processing Services Trust)',
                account: 'BSB: 064462, A/C: 10254283',
                rate: 0.0
            },
            {
                email: 'matt.ireland.home@gmail.com',
                abn: '1234567890',
                account: 'BSB: 000000, A/C: 12345678',
                rate: 0.15
            },
            {
                email: 'vicki.renouf@insightprocessing.com.au',
                abn: '92156674105',
                account: 'BSB: 014504, A/C: 300856871',
                rate: 0.15
            },
            {
                uid: 'mMJSgZ2W2XgT0JUfOG1mNnbd7OE2',
                email: 'shannon.mcleish@insightprocessing.com.au',
                abn: '80 823 244 516',
                account: 'BSB: 064462, A/C: 10307269',
                rate: 0.1,
                address: 'PO Box 369, Dalby Qld 4405'
            },
            {
                uid: 'bPZAmX6EbKSVWA6fJ3RkCeVUv8i1',
                email: 'kate.gorman@insightprocessing.com.au',
                abn: '56 793 528 824',
                account: 'BSB:306-134 Acc:0947 027',
                rate: 0.15,
                address: '46 Hickford St, Brunswick East VIC 3057'
            },

            {
                uid: 'a2Sy21W9MwcuvkS2Sjn4AIB8RQF2',
                email: 'damian.simmons@insightprocessing.com.au',
                abn: '93 156 970 364',
                account: 'BSB:814-282 Acc:50576773',
                rate: 0.1,
                address: '2 Torana Ct, South Bingera Q 4670'
            },
            {
                uid: 'JqYWK2x7bkSZjNfyzjSqLimhGRz2',
                email: 'tess.pitcher@insightprocessing.com.au',
                abn: '94 130 145 517',
                entity: 'Pitcher Family Trust',
                account: 'BSB:014616 Acc: 151207703',
                rate: 0.15,
                address: '10 Cary Street, Woombye QLD'
            },
            {
                email: 'tess.pitcher1@mortgagechoice.com.au',
                uid: 'JqYWK2x7bkSZjNfyzjSqLimhGRz2',
                abn: '94 130 145 517',
                entity: 'Pitcher Family Trust',
                account: 'BSB:014616 Acc:151207703',
                rate: 0.15,
                address: '10 Cary Street, Woombye QLD'
            },
            {
                email: 'nic.papandrea@insightprocessing.com.au',
                uid: 'dF1F48bHkSaT8cFCQzIwafsPcCH3',
                abn: '75 169 776 194 (Henj Pty Ltd)',
                account: 'BSB:084 004  Acc: 91-693-3767',
                rate: 0.15,
                address: '8 Waterford Ct, Maroochydore 4558'
            },
            {
                email: 'kristin.mcleish@insightprocessing.com.au',
                abn: '91 786 286 393',
                account: 'BSB:064462 Acc:10254283',
                rate: 0.15,
                address: '139 Queen Street, Maryborough QLD 4650'
            },
            {
                uid: 'P1iLuvCOHWatoTJNAaoEXqWhP0v2',
                email: 'hayley.wyatt@insightprocessing.com.au',
                abn: '62 639 442 286',
                account: 'BSB 085-005 Acct 309353592',
                rate: 0.1,
                address: '38 Chapel Road Modbury North SA 5092'
            },
            {
                uid: 'MOuMD8KFKZV9yxVZPe2FQRbpfF93',
                email: 'robynne.duncan@insightprocessing.com.au',
                abn: '95 625 020 028',
                account: 'BSB 533-000 Acct 10656328',
                rate: 0.15,
                entity: 'Hunter Commercial Pty Ltd',
                address: 'PO Box 91 Maroochydore Q 4558'
            },
            {
                uid: 'FCXzwTED9WRM6bZFvExHCEq0cyG3',
                email: 'kim.robinson@insightprocessing.com.au',
                abn: '68 572 795 443',
                account: 'BSB 484-799 Acct 052368080',
                rate: 0.15,
                entity: 'Kim Robinson',
                address: '16 Clive St, Tenterfield NSW  2372',
            },
            {
                email: 'matt.driscoll@insightprocessing.com.au',
                abn: '75 629 059 516',
                account: 'BSB:xxxx Acc:xxxxx',
                rate: 0.15
            },
            {
                email: 'linda.carr@insightprocessing.com.au',
                abn: '43 806 290 094',
                account: 'BSB:734 655 Acc:596 047',
                rate: 0.15,
                address: '79 Neurum Rd, Yaroomba Q 4573'
            },
            {
                email: 'shelly.hope@insightprocessing.com.au',
                abn: '56 918 763 572',
                account: 'BSB:923 100 Acc:305472219',
                rate: 0.15,
                address: '84 Tooley Street, Maryborough Q 4650'
            },
            {
                uid: 'opv1HwNvyHYAVUO8ZazZ5i2rLWT2',
                email: 'tiani.cantwell@insightprocessing.com.au',
                abn: '45 737 219 858',
                account: 'BSB:923 100 Acc:3061 34846',
                rate: 0.15,
                address: 'Unit1, 21-25 Garners Avenue, Marrickville NSW 2204'
            },
            {
                uid: '1tLZJ6exz2hNFjJmUYYn2QKtsCb2',
                email: 'nicole.hogan@insightprocessing.com.au',
                abn: '81 552 384 365',
                account: 'BSB:082-155 Acc:75-105-1407',
                rate: 0.15,
                address: '5/11-13 Myahgah Road, Mosman NSW 2088'
            },
            {
                uid: 'NPlRptCknbcMmdo74EDNA8JnIHg1',
                email: 'juliet.welsh@insightprocessing.com.au',
                abn: '91156727792',
                account: 'BSB 734 065, Acc 602910',
                rate: 0.15,
                address: ''
            },
            {
                uid: 'HM78oWztxgh6rvTM5fSLlczP1by2',
                email: 'daniel.hausler@insightprocessing.com.au',
                abn: '35759660448',
                account: 'BSB 014512, Acc 321980767',
                rate: 0.15,
                address: '11/55 Buderim Ave Mooloolaba QLD 4557'
            },
            {
                uid: 'ER0TdSKsRdd3SM57qatRoRirD083',
                email: 'vikki.hanning@insightprocessing.com.au',
                abn: '80 646 466 444',
                account: 'BSB 062-692, Acc 42910332',
                rate: 0.1,
                address: '2/65 Dane St, East Victoria Park, WA 6101'
            },
            // {
            //     uid: '',
            //     email: 'xxx@insightprocessing.com.au',
            //     abn: '',
            //     account: 'BSB , Acc ',
            //     rate: 0.15,
            //     address: ''
            // },

        ]
    }

    static snippets() {
        return [
            {
                title: 'Emailed Client',
                text: 'Emailed client',
                category: 'Comments'
            },
            {
                title: 'Called Client',
                text: 'Called client. Spoke with client.',
                category: 'Comments'
            },
            {
                title: 'Called No Answer',
                text: 'Called client. No Answer.',
                category: 'Comments'
            },
            {
                title: 'Called Voicemail',
                text: 'Called client. Left voicemail.',
                category: 'Comments'
            },
            {
                title: 'Called with Update',
                text: 'Called client. Updated on progress.',
                category: 'Comments'
            },
            {
                title: 'Called Lender',
                text: 'Called lender for update.',
                category: 'Comments'
            },
        ]
    }

    static months = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ]



    static outstandingStatuses() {
        return ['Waiting for Client', 'Waiting for Broker', 'Waiting for Processor', 'Lender to Complete', 'Ready to Send', 'Settlement Condition', 'Sent']
    }

    static lenders() {
        return [
            {name:'ANZ'},
            {name:'CBA'},
            {name:'Westpac'},
            {name:'NAB'},
            {name:'Pepper'},
            {name:'Suncorp'},
            {name:'St George'},
            {name:'Heritage'},
            {name:'ING Direct'},
            {name:'Macquarie'},
        ]
    }

}


// WEBPACK FOOTER //
// ./src/helpers/LookupData.js